import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";
import SelectFilter from "./SelectFilter";

const SelectFilterTags = ({ store, setTagFilter, languageContext, sx }) => {
  const handleChange = (index, value = 0) => {
    const newSelectedTags = [...store.filter.selectedTags];
    newSelectedTags[index] = value ?? 0;
    store.selectedFilterTags(newSelectedTags);
    setTagFilter(index, value);
  };

  return (
    <BaseGrid direction="column">
      {store.tags.map((tag, i) => (
        <SelectFilter
          fullWidth={true}
          key={tag.categoryId}
          name={languageContext(tag.title)}
          value={store.filter.selectedTags[i]}
          onChange={(value) => handleChange(i, value)}
          options={[
            { value: 0, label: languageContext("all") },
            ...tag.values.map((o) => ({
              value: o.valueId.toString(),
              label: o.title,
            })),
          ]}
          languageContext={languageContext}
          className="filter-select-category-tags"
          sx={sx}
        />
      ))}
    </BaseGrid>
  );
};

export default SelectFilterTags;
